<template>
  <div class="modal-box">
    <div class="modal-title">
      <h3>Nieuwe Ruimte</h3>
      <div class="flex-divider"></div>
      <base-button type="secondary" @click="closeModal">
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content">
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Basisgegevens</h4>
        </div>
        <div class="input-container">
          <label class="label required" for="roomName">Ruimtenaam</label>
          <base-input
            type="text"
            id="roomName"
            name="roomName"
            placeholder="Ruimtenaam"
            v-model="newRoomData.roomName"
            data-vv-as="Ruimtenaam"
            v-validate="'required'"
          />
          <base-input-warning :error="errors.first('roomName')" />
        </div>
        <div class="input-container">
          <label for class="label">Beschrijving</label>
          <textarea
            class="input"
            rows="4"
            placeholder="Beschrijving"
            v-model="newRoomData.description"
          ></textarea>
        </div>
      </div>
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Eigenschappen</h4>
        </div>
        <div class="input-container">
          <label class="label required" for="roomType">Ruimtesoort</label>
          <select
            id="roomType"
            name="roomType"
            class="input"
            v-bind:value="newRoomData.type"
            @change="newRoomData.type = $event.target.value"
            data-vv-as="Ruimtesoort"
            v-validate="'required'"
          >
            <option
              v-for="option in roomTypeOptions"
              :key="option.id"
              :value="option.id"
            >{{option.label}}</option>
          </select>
          <base-input-warning :error="errors.first('roomType')" />
        </div>
        <div class="input-row">
          <div class="input-container">
            <label class="label required" for="roomWidth">Breedte (m)</label>
            <base-input
              id="roomWidth"
              name="roomWidth"
              type="number"
              placeholder="0"
              v-model="newRoomData.width"
              data-vv-as="Breedte"
              v-validate="'required'"
              step="0.1"
            />
            <base-input-warning :error="errors.first('roomWidth')" />
          </div>
          <div class="input-container">
            <label class="label required" for="roomLength">Lengte (m)</label>
            <base-input
              id="roomLength"
              name="roomLength"
              type="number"
              placeholder="0"
              v-model="newRoomData.length"
              data-vv-as="Lengte"
              v-validate="'required'"
              step="0.1"
            />
            <base-input-warning :error="errors.first('roomLength')" />
          </div>
          <div class="input-container">
            <label class="label required" for="roomHeight">Hoogte (m)</label>
            <base-input
              id="roomHeight"
              name="roomHeight"
              type="number"
              placeholder="0"
              v-model="newRoomData.height"
              data-vv-as="Hoogte"
              v-validate="'required'"
              step="0.1"
            />
            <base-input-warning :error="errors.first('roomHeight')" />
          </div>
        </div>
        <!-- <div class="input-row">
          <div class="input-container">
            <label
              class="label required"
              for="peopleAmount"
            >Aantal personen</label>
            <base-input
              id="peopleAmount"
              name="peopleAmount"
              type="number"
              placeholder="0"
              v-model="newRoomData.people.amount"
              data-vv-as="Aantal personen"
              v-validate="'required'"
              step="1"
            />
            <base-input-warning :error="errors.first('peopleAmount')" />
          </div>
          <div class="input-container">
            <label class="label required">Gedrag personen</label>
            <select
              class="input"
              v-bind:value="newRoomData.people.type"
              @change="newRoomData.people.type = $event.target.value"
              name="peopleType"
              data-vv-as="Gedrag personen"
              v-validate="'required'"
            >
              <option
                v-for="option in $peopleTypes"
                :key="option.value"
                :value="option.value"
              >{{option.label}}</option>
            </select>
            <base-input-warning :error="errors.first('peopleType')" />
          </div>
        </div>-->
        <div class="input-row">
          <div class="input-container">
            <label class="label required">Interieur</label>
            <select
              class="input"
              v-bind:value="newRoomData.interior"
              @change="newRoomData.interior = $event.target.value"
              name="interior"
              data-vv-as="Interieur"
              v-validate="'required'"
            >
              <option
                v-for="option in $interiors"
                :key="option.value"
                :value="option.value"
              >{{option.label}}</option>
            </select>
            <base-input-warning :error="errors.first('interior')" />
          </div>
          <div class="input-container">
            <label class="label required">Extra wensen</label>
            <select
              class="input"
              v-bind:value="newRoomData.wishes"
              @change="newRoomData.wishes = $event.target.value"
              name="wishes"
              data-vv-as="Extra wensen"
              v-validate="'required'"
            >
              <option
                v-for="option in $wishes"
                :key="option.value"
                :value="option.value"
              >{{option.label}}</option>
            </select>
            <base-input-warning :error="errors.first('wishes')" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-divider"></div>
      <base-button @click="closeModal" type="secondary">Annuleren</base-button>
      <base-button @click="createRoom" :loading="creatingRoom" :disabled="creatingRoom">
        <base-icon iconRef="checkmark" position="left" />Aanmaken
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "room-create-modal",
  data: function () {
    return {
      creatingRoom: false,
      newRoomData: {
        roomName: "",
        description: "",
        height: "",
        length: "",
        width: "",
        type: "",
        interior: "",
        people: {
          type: "",
          amount: "",
        },
        wishes: "",
      },
    };
  },
  computed: {
    roomTypeOptions: function () {
      return this.$store.getters.getActiveAdvicevaluesList;
    },
  },
  methods: {
    createRoom: function () {
      this.$validator.validate().then((result) => {
        if (result) {
          this.creatingRoom = true;
          const newRoom = this.$createNewRoom(this.newRoomData);
          newRoom.belongsTo = this.$route.params.projectId;
          this.$firestore
            .collection("rooms")
            .add(newRoom)
            .then((doc) => {
              this.creatingRoom = false;
              this.closeModal();
              this.$router.push("/ruimte/" + doc.id);
            });
        }
      });
    },
    closeModal: function () {
      this.$store.commit("setModalShown", {
        dataType: "room",
        modalType: "create",
        shown: false,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/room-create-modal.vue